export function isValidCuit(value) {
    if (value === null || value === undefined || String(value).trim() === '') {
        return true
    }

    const cuit = String(value).trim()
    if (!/^(?:\d{11}|\d{2}-\d{8}-\d)$/.test(cuit)) {
        return false
    }

    const digits = cuit.replace(/-/g, '')
    const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
    const sum = weights.reduce((total, weight, index) => total + Number(digits[index]) * weight, 0)
    const remainder = sum % 11
    const checkDigit = remainder === 0 ? 0 : remainder === 1 ? 9 : 11 - remainder

    return checkDigit === Number(digits[10])
}

export function validationError(value) {
    return isValidCuit(value) ? null : 'El CUIT no es válido.'
}
